import { render, staticRenderFns } from "./header-area.vue?vue&type=template&id=5a647f23&scoped=true&"
import script from "./header-area.vue?vue&type=script&lang=js&"
export * from "./header-area.vue?vue&type=script&lang=js&"
import style0 from "./header-area.vue?vue&type=style&index=0&id=5a647f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a647f23",
  null
  
)

export default component.exports